import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { ShoppingCart, ExternalLink } from 'lucide-react';

const ProductCard = ({ item, formatPrice, onCardClick }) => {
 const handleBuyNow = (e) => {
 e.stopPropagation();
 if (item.external_url) {
 window.open(item.external_url, '_blank');
 }
 };

 return (
 <Card 
 className="shadow-lg overflow-hidden card-hover cursor-pointer transition-transform hover:scale-105" 
 data-testid="store-item-card"
 onClick={() => onCardClick(item)}
 >
 {/* Product Image */}
 <div className="aspect-video bg-gradient-to-br from-orange-200 to-yellow-200 flex items-center justify-center overflow-hidden relative">
 {item.image ? (
 <img 
 src={item.image} 
 alt={item.name}
 className="w-full h-full object-cover"
 onError={(e) => {
 e.target.style.display = 'none';
 e.target.parentElement.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-16 h-16 text-white"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
 }}
 />
 ) : (
 <ShoppingCart className="w-16 h-16 text-white" />
 )}
 
 {/* Sale Banner */}
 {item.on_sale && (
 <div className="absolute top-0 right-0 bg-red-600 text-white px-3 py-1 font-bold text-sm shadow-lg transform rotate-0">
 🏷️ SALE
 {item.msrp && item.msrp > item.price && (
 <span className="block text-xs">
 {Math.round(((item.msrp - item.price) / item.msrp) * 100)}% OFF
 </span>
 )}
 </div>
 )}
 </div>

 {/* Product Info */}
 <CardHeader>
 <div className="flex items-start justify-between gap-2">
 <div className="flex-1">
 <CardTitle className="text-lg">{item.name}</CardTitle>
 
 {/* Company Logo */}
 {item.company_logo && (
 <div className="mt-1 mb-2">
 <img 
 src={item.company_logo} 
 alt="Sold by" 
 className="h-6 object-contain"
 onError={(e) => e.target.style.display = 'none'}
 />
 </div>
 )}
 
 {/* Machine Name */}
 {item.machine_name && (
 <p className="text-sm text-slate-600 dark:text-neutral-400 mt-1">
 🔧 {item.machine_name}
 </p>
 )}
 
 {/* Price Display */}
 <div className="mt-2">
 {item.msrp && item.msrp > item.price ? (
 <>
 <p className="text-sm text-slate-500 line-through">
 {formatPrice(item.msrp)}
 </p>
 <p className="text-2xl font-bold text-red-600">
 {formatPrice(item.price)}
 </p>
 <p className="text-xs text-green-600 font-semibold">
 Save {formatPrice(item.msrp - item.price)}
 </p>
 </>
 ) : (
 <p className="text-2xl font-bold text-orange-600">{formatPrice(item.price)}</p>
 )}
 </div>
 </div>
 
 {/* Category Badge */}
 <span className="inline-block bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300 text-xs font-medium px-2.5 py-0.5 rounded">
 {item.category}
 </span>
 </div>
 
 {/* Description */}
 {item.description && (
 <CardDescription className="mt-2">{item.description}</CardDescription>
 )}
 </CardHeader>

 {/* Buy Button */}
 <CardContent>
 <p className="text-xs text-slate-500 dark:text-neutral-500 text-center mb-2">
 Click card for details
 </p>
 {item.external_url ? (
 <Button
 className="w-full"
 onClick={handleBuyNow}
 data-testid="buy-now-btn"
 >
 Buy Now <ExternalLink className="w-4 h-4 ml-2" />
 </Button>
 ) : (
 <Button className="w-full" disabled>
 Coming Soon
 </Button>
 )}
 </CardContent>
 </Card>
 );
};

export default ProductCard;
